var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"title-post"},[_c('div',{staticClass:"data"},[_c('div',{staticClass:"dia"},[_vm._v(_vm._s(_vm.dia))]),_vm._v(" "),_c('div',{staticClass:"mes"},[_vm._v(_vm._s(_vm.mes))])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bce593d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/vue/components/Post/PostTitle.vue
// module id = 24
// module chunks = 0